import { rapidReady, ylkStringToObj } from '../../../../lib/utils/rapid'

export default (() => {
  class LNAVBackdropController {
    constructor(parentNode, selector = '.navrail_subitem') {
      this.elems = [...document?.querySelectorAll(selector)]
      this.enableBackDrop = false
      if (!this.elems.length) {
        return
      }

      const lnavElem = document?.getElementById('m-ahlb-navrail-id')
      if (!lnavElem) {
        return
      }

      const {
        dataset: { defaultItem }
      } = lnavElem
      this.defaultItem = defaultItem
      this.defaultLnavNavrailElems = document?.querySelectorAll('#left-wrap_id ul.navrail')
      this.lnavNavrailElems = document?.querySelectorAll('#m-ahlb-navrail-id ul.navrail')
      this.mwebLnavNavrailElems = document?.querySelectorAll('#lnav-mweb-flyout ul.navrail')
      this.navrailContainerElem = document.querySelector('.m-ahlb')
      this.defaultLNavContainerElem = document.getElementById('left-wrap_id')
      this.navElem = document.querySelector('.m-ahlb .navrail-container')
      this.defaultLNavElem = document.querySelector('#left-wrap_id .navrail-container')
      this.mwebLNavElem = document.querySelector('#lnav-mweb-flyout')

      if (
        !this.defaultLnavNavrailElems.length ||
        !this.lnavNavrailElems.length ||
        !this.mwebLnavNavrailElems.length ||
        !this.navrailContainerElem ||
        !this.defaultLNavContainerElem ||
        !this.navElem ||
        !this.defaultLNavElem
      ) {
        return
      }

      this.transitionTime = 200
      this.focusableItems = [...this.lnavNavrailElems]
      this.defaultFocusableItems = [...this.defaultLnavNavrailElems]
      this.mwebLnavFocusableItems = [...this.mwebLnavNavrailElems]

      this.updateLNavUI({
        updateMenuItem: this.defaultItem,
        forceToUpdate: true
      })

      this.btns = [...this.elems]
      this._init()
    }

    updateLNavElems(elems, updateMenuItem) {
      elems.forEach(elem => {
        elem?.classList?.add('hide')
        if (elem?.dataset?.customLabel === updateMenuItem) {
          elem.classList?.remove('hide')
        }
      })
    }

    updateLNavUI(config) {
      const { updateMenuItem = '', forceToUpdate = false, forceToUpdateForMWeb = false } = config
      this.updateLNavElems(this.lnavNavrailElems, updateMenuItem)

      if (forceToUpdate) {
        this.updateLNavElems(this.defaultLnavNavrailElems, updateMenuItem)
      }

      if (forceToUpdate || forceToUpdateForMWeb) {
        this.updateLNavElems(this.mwebLnavNavrailElems, updateMenuItem)
      }
    }

    _init() {
      this._addEventListeners()
    }

    _addEventListeners() {
      this.btns?.forEach(btn => btn.addEventListener('click', this._handleClick.bind(this)))

      document.addEventListener('click', evt => {
        if (
          this.enableBackDrop &&
          !(
            evt.target.closest('.navrail') ||
            evt.target.closest('.navrail_subitem') ||
            evt.target.closest('.m-ahlb-right')
          )
        ) {
          this._handleBackToDefaulState()
        }
      })

      document.addEventListener('keyup', evt => {
        if (this.enableBackDrop && evt?.keyCode === 27) {
          this._handleBackToDefaulState()
        }
      })
    }

    async _handleBackToDefaulState() {
      this.enableBackDrop = false
      this._handleLnavClick({
        defaultState: true
      })
      this._handleMWebDefaulState()
    }

    async _handleMWebDefaulState() {
      this.enableBackDrop = false
      this.updateLNavElems(this.mwebLnavNavrailElems, this.defaultItem)
    }

    _cleanupAnimation() {
      this.navElem?.classList.remove('translate_left')
      this.defaultLNavElem?.classList.remove('translate_left')
      this.navElem?.classList.remove('translate_right')
      this.defaultLNavElem?.classList.remove('translate_right')
      this.navrailContainerElem?.classList.remove('fadeout')
    }

    async _handleLnavClick({ defaultState = false, toLevel, elementValue }) {
      if (this.navrailContainerElem && this.defaultLNavContainerElem) {
        this._cleanupAnimation()

        if (elementValue === this.defaultItem || defaultState) {
          this.enableBackDrop = false
          this.navrailContainerElem?.classList.remove('hide')
          this.navElem?.classList.add('translate_left')
          setTimeout(() => {
            this.updateLNavUI({ updateMenuItem: this.defaultItem })
            this.navrailContainerElem?.classList.add('fadeout')
            setTimeout(() => {
              this.defaultLNavElem?.classList.add('translate_right')
              this.defaultLNavContainerElem?.classList.remove('hide')
              this._focusOnFirstElem(this.defaultFocusableItems)
              setTimeout(() => {
                this.defaultLNavElem?.classList.remove('translate_left')
                this.navElem?.classList.remove('translate_left')
                this.defaultLNavElem?.classList.remove('translate_right')
                this.navrailContainerElem?.classList.add('hide')
                this.navrailContainerElem?.classList.remove('fadeout')
              }, this.transitionTime / 2)
            }, this.transitionTime / 2)
          }, this.transitionTime / 2)
        } else {
          this.enableBackDrop = true
          this.defaultLNavElem?.classList.add('translate_left')
          setTimeout(() => {
            if (Number(toLevel) <= 1) {
              this.updateLNavUI({ updateMenuItem: 'default_1_2' })
            } else {
              this.updateLNavUI({ updateMenuItem: elementValue })
            }
            this.navElem?.classList.remove('translate_left')
            this.defaultLNavElem?.classList.remove('translate_left')
            this.navrailContainerElem?.classList.remove('hide')
            this.defaultLNavContainerElem?.classList.add('hide')
            this.navElem?.classList.add('translate_right')
            this._focusOnFirstElem(this.focusableItems)
            setTimeout(() => {
              this.navElem?.classList.remove('translate_right')
            }, this.transitionTime / 1.5)
          }, this.transitionTime)
        }
      }
    }

    _handleLnavClickForMWeb({ defaultState = false, toLevel, elementValue }) {
      this.mwebLNavElem?.classList.remove('transition_left')
      this.mwebLNavElem?.classList.remove('transition_right')
      this.mwebLNavElem?.classList.add('transition_left')

      setTimeout(() => {
        if (elementValue === this.defaultItem || defaultState) {
          this.enableBackDrop = false
          this.updateLNavUI({ updateMenuItem: this.defaultItem, forceToUpdateForMWeb: true })
        } else if (Number(toLevel) <= 1) {
          this.enableBackDrop = true
          this.updateLNavUI({
            updateMenuItem: 'default_1_2',
            forceToUpdateForMWeb: true
          })
        } else {
          this.enableBackDrop = true
          this.updateLNavUI({
            updateMenuItem: elementValue,
            forceToUpdateForMWeb: true
          })
        }

        this.mwebLNavElem?.classList.add('transition_right')
        this._focusOnFirstElem(this.mwebLnavFocusableItems)
        const flyoutContainerElem = document.querySelector('.m-flyout__container--left-fixed')
        flyoutContainerElem.scroll(0, 0)
        this.mwebLNavElem?.classList.remove('transition_left')
        setTimeout(() => {
          this.mwebLNavElem?.classList.remove('transition_right')
        }, this.transitionTime)
      }, this.transitionTime)
    }

    _handleClick(e) {
      const menuItemElm = e.currentTarget
      const { dataset } = menuItemElm
      const { lnavKey, parentLabel } = dataset
      let { fromLevel, toLevel } = dataset
      fromLevel = Number(fromLevel)
      toLevel = Number(toLevel)
      let elementValue = 'default_1_2'
      if (fromLevel < toLevel) {
        fromLevel += 1
        toLevel += 1

        const elementKey = menuItemElm.querySelector('.text-label').innerText
        if (elementKey) {
          elementValue = `${elementKey
            ?.toLowerCase()
            ?.split(' ')
            ?.join('_')}_${fromLevel}_${toLevel}`
        }
      } else if (fromLevel > toLevel) {
        if (Number(toLevel) <= 1) {
          elementValue = 'default_1_2'
        } else {
          const temp = fromLevel
          fromLevel = toLevel
          toLevel = temp
          elementValue = parentLabel
        }
      }

      if (lnavKey !== 'mweb') {
        this._handleLnavClick({ toLevel, elementValue })
      } else if (lnavKey === 'mweb') {
        this._handleLnavClickForMWeb({ toLevel, elementValue })
      }
    }

    _focusOnFirstElem(elems) {
      if (elems.length) {
        for (let index = 0; index < elems.length; index++) {
          if (!elems[index]?.classList?.contains('hide')) {
            const elem = elems[index]?.querySelectorAll('li a,li button')
            if (elem.length) {
              elem[0].focus()
            }
            break
          }
        }
      }
    }

    rapidBeacon(target, overridesYlk = {}) {
      const { ylk = {} } = target?.dataset
      let ylkObj = ylkStringToObj(ylk)
      ylkObj = { ...ylkObj, ...overridesYlk }
      rapidReady(rapid => {
        rapid.beaconClick(ylkObj.sec, ylkObj.slk, ylkObj.itc, ylkObj)
      })
    }
  }

  return LNAVBackdropController
})()
